import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import * as d3 from 'd3';
import { SpeedometerModel } from 'src/app/models/Speedometer';

declare var d3: any;

@Component({
  selector: 'app-speedometer-chart',
  templateUrl: './speedometer-chart.component.html',
  styleUrls: ['./speedometer-chart.component.css']
})
export class SpeedometerChartComponent implements OnInit {
  @Input() input: any;
  gaugemap = new SpeedometerModel;

  constructor() { }
  ngOnInit() {  }
   ngOnChanges() {
    if(this.input != undefined && this.input != null ){
      setTimeout(() => { this.draw(this.input); }, 500);
    }   
  }
 
  draw(input) {    
    let that = this;
    let containerId = "#container_"+input[1];
    let containerIdwithoutHash = containerId.split('#')[1];
    let divId = '#div_' + containerIdwithoutHash;
    d3.select(containerId).html("");
    d3.select(containerId).append("div").attr('id', 'div_' + containerIdwithoutHash);
    d3.select(divId).classed('power-gauge', true);
    let svgWidth = d3.select(containerId).node().offsetWidth;
    let svgHeight = 200;

    var gauge = function (container, configuration) {
      var config = {
        size: 710,
        size1: 500,
        clipWidth: svgWidth,
        clipHeight: svgHeight,
        ringInset: svgWidth/5.6,
        ringInset1: 20,
        ringWidth: 18,
        ringWidth1: 10,

        pointerWidth: 11,
        pointerTailLength: 5,
        pointerHeadLengthPercent: 0.9,

        minValue: 0,
        maxValue: 10,

        minAngle: -90,
        maxAngle: 90,

        transitionMs: 750,

        majorTicks: 4,
        labelFormat: d3.format('d'),
        labelInset: 10,

        arcColorFn: d3.interpolateHsl(d3.rgb('#C6E3EF'), d3.rgb('#6C79CF'))
      };
      var range = undefined;
      var r = undefined;
      var pointerHeadLength = undefined;
      var value = 0;

      var svg = undefined;
      var arc = undefined;
      var arc1 = undefined;
      var arc2 = undefined;
      var arc3 = undefined;
      var scale = undefined;
      var ticks = undefined;
      var tickData = undefined;
      var pointer = undefined;

      var donut = d3.pie();

      function deg2rad(deg) {
        return (deg * Math.PI) / 180;
      }

      function newAngle(d) {
        var ratio = scale(d);
        var newAngle = config.minAngle + ratio * range;
        return newAngle;
      }

      function configure(configuration) {
        var prop = undefined;
        for (prop in configuration) {
          config[prop] = configuration[prop];
        }

        range = config.maxAngle - config.minAngle;
        r = config.size / 2;
        pointerHeadLength = 90;

        // a linear scale this.gaugemap maps domain values to a percent from 0..1
        scale = d3
          .scaleLinear()
          .range([0, 1])
          .domain([config.minValue, config.maxValue]);

        // ticks = scale.ticks(config.majorTicks);
        ticks = [0, 25, 50, 75, 100]
        tickData = d3.range(1).map(function () {
          return 1;
        });

        if(containerId=="#container_0"){
          arc = d3
          .arc()
          .innerRadius(r - config.ringWidth - config.ringInset1 - 7)
          .outerRadius(r - config.ringInset1 - 7)
          .startAngle(function (d, i) {
            var ratio = d * i;
            return deg2rad(config.minAngle + ratio * range);
          })
          .endAngle(function (d, i) {
            var ratio = d * (i + 1);
            return deg2rad(config.minAngle + ratio * range);
          });

        arc1 = d3
          .arc()
          .innerRadius(r - 105)
          .outerRadius(r - 150)
          .startAngle(function (d, i) {
            var ratio = d * i;
            return deg2rad(config.minAngle + ratio * range);
          })
          .endAngle(function (d, i) {
            var ratio = d * (i + 1);
            return deg2rad(config.minAngle + ratio * range);
          });

        arc2 = d3
          .arc()
          .innerRadius(r - 96)
          .outerRadius(r - 98)
          .startAngle(function (d, i) {
            var ratio = d * i;
            return deg2rad(config.minAngle + ratio * range);
          })
          .endAngle(function (d, i) {
            var ratio = d * (i + 1);
            return deg2rad(config.minAngle + ratio * range);
          });

        arc3 = d3
          .arc()
          .innerRadius(r - 17)
          .outerRadius(r - 19)
          .startAngle(function (d, i) {
            var ratio = d * i;
            return deg2rad(config.minAngle + ratio * range);
          })
          .endAngle(function (d, i) {
            var ratio = d * (i + 1);
            return deg2rad(config.minAngle + ratio * range);
          });

        }
        else{
        arc = d3
          .arc()
          .innerRadius(r - config.ringWidth - config.ringInset - (svgWidth/40))
          .outerRadius(r - config.ringInset - (svgWidth/40))
          .startAngle(function (d, i) {
            var ratio = d * i;
            return deg2rad(config.minAngle + ratio * range);
          })
          .endAngle(function (d, i) {
            var ratio = d * (i + 1);
            return deg2rad(config.minAngle + ratio * range);
          });

        arc1 = d3
          .arc()
          .innerRadius(r - (svgWidth/2.4))
          .outerRadius(r - r)
          .startAngle(function (d, i) {
            var ratio = d * i;
            return deg2rad(config.minAngle + ratio * range);
          })
          .endAngle(function (d, i) {
            var ratio = d * (i + 1);
            return deg2rad(config.minAngle + ratio * range);
          });

        arc2 = d3
          .arc()
          .innerRadius(r - (svgWidth/2.52))
          .outerRadius(r - ((svgWidth/2.52)+2))
          .startAngle(function (d, i) {
            var ratio = d * i;
            return deg2rad(config.minAngle + ratio * range);
          })
          .endAngle(function (d, i) {
            var ratio = d * (i + 1);
            return deg2rad(config.minAngle + ratio * range);
          });

        arc3 = d3
          .arc()
          .innerRadius(r - (svgWidth/5.7))
          .outerRadius(r - ((svgWidth/5.7) + 2))
          .startAngle(function (d, i) {
            var ratio = d * i;
            return deg2rad(config.minAngle + ratio * range);
          })
          .endAngle(function (d, i) {
            var ratio = d * (i + 1);
            return deg2rad(config.minAngle + ratio * range);
          });
        }
      }
      that.gaugemap.configure = configure;

      function centerTranslation() {
        if(svgWidth>250){
          var a = 130;
        }
        else{
          var a = 110;
        }
        return 'translate(' + a + ',' + 150 + ')';
      }

      function centerTranslation1() {
        if(svgWidth>=500){
          var ct = svgWidth/2.2
        }
        else if(svgWidth>=450 && svgWidth<500){
          var ct = svgWidth/2.3
        }
        else if(svgWidth>=400 && svgWidth<450){
          var ct = svgWidth/2.4
        }
        else if(svgWidth<400){
          var ct = svgWidth/2.5
        }
        return 'translate(' + ct + ',' + r + ')';
      }

      function isRendered() {
        return svg !== undefined;
      }
      that.gaugemap.isRendered = isRendered;

      function render(newValue) {

        if(containerId=="#container_0") {
          svg = d3
          .select(containerId)
          .append('svg:svg')
          .attr('class', 'gauge')
          .classed("resizableSVG", true)
          .attr('id', 'svg_' + containerIdwithoutHash)
          .attr('width', config.clipWidth)
          .attr('height', config.clipHeight)

          if(svgWidth>=500){
            var px = 130
            var gx = 330
          }
          else if(svgWidth>=450 && svgWidth<500){
            var px = 90
            var gx = 290
          }
          else if(svgWidth>=400 && svgWidth<450){
            var px = 65
            var gx = 260
          }
          else if(svgWidth<400){
            var px = 35
            var gx = 230
          }
            svg.append('text')
            .attr('class', 'arc')
            .attr('dy', +170) // hard-coded. can adjust this to adjust text vertical alignment in tooltip
            .attr('dx',+px)
            .html('POOR') 
            .style('font-size', '11px')
            svg.append('text')
            .attr('class', 'arc')
            .attr('dy', +170) // hard-coded. can adjust this to adjust text vertical alignment in tooltip
            .attr('dx',+gx)
            .html('GOOD') 
            .style('font-size', '11px')
            
  
          // var centerTx = centerTranslation();
          var centerTx = centerTranslation1();
          var color = ['#C6E3EF', '#67B7DC','#6998D6','#6C79CF'];
  
          var arcs = svg
            .append('g')
            .attr('class', 'arc')
            .attr('transform', centerTx)
            
          arcs
        .append("linearGradient")
        .attr("id", "line-gradient")
        .attr("gradientUnits", "userSpaceOnUse")
        .attr("x1", -90)
        .attr("y1", 10)
        .attr("x2", 60)
        .attr("y2", 25)
        .attr("x3", 70)
        .attr("y3", 50)
        .attr("x4", 75)
        .attr("y4", 75)
        .selectAll("stop")
          .data([
            {offset: "0%", color: "#C6E3EF"},
            {offset: "25%", color: "#67B7DC"},
            {offset: "50%", color: "#6998D6"},
            {offset: "100%", color: "#6C79CF"}
  
          ])
        .enter().append("stop")
          .attr("offset", function(d) { return d.offset ; })
          .attr("stop-color", function(d) { return d.color; });  
  
          arcs
          .selectAll('path')
        .data(tickData)
        .enter()
        .append('path')
        .attr('d', arc)
        .attr("fill", "url(#line-gradient)")
        .attr("stroke", "url(#line-gradient)" )
        .attr("stroke-width", 2)
       
          
          var arcs1 = svg
            .append('g')
            .attr('class', 'arc1')
            .attr('transform', centerTx)
            
            if(svgWidth>=500){
              var ip = 230
            }
            else if(svgWidth>=450 && svgWidth<500){
              var ip = 190
            }
            else if(svgWidth>=400 && svgWidth<450){
              var ip = 153
            }
            else if(svgWidth<400){
              var ip = 125
            }
            svg.append('text')
            .attr('class', 'arc')
            .attr('dy', +135) // hard-coded. can adjust this to adjust text vertical alignment in tooltip
            .attr('dx',+ip)
            .html(input[0]+"%") 
            .style('font-size', '20px')
            .style('fill', 'white')
  
          arcs1
            .selectAll('path')
            .data(tickData)
            .enter()
            .append('path')
            .attr('fill', function (d, i) {
              return config.arcColorFn();
            })
            .attr('d', arc1)
            .style('opacity',0.8);
          
          var arcs2 = svg
            .append('g')
            .attr('class', 'arc2')
            .attr('transform', centerTx);
  
          arcs2
            .selectAll('path')
            .data(tickData)
            .enter()
            .append('path')
            .attr('fill', function (d, i) {
              return config.arcColorFn();
            })
            .attr('d', arc2)
            .style('opacity',0.7);
          
          var arcs3 = svg
            .append('g')
            .attr('class', 'arc3')
            .attr('transform', centerTx);
  
          arcs3
            .selectAll('path')
            .data(tickData)
            .enter()
            .append('path')
            .attr('fill', function (d, i) {
              return config.arcColorFn();
            })
            .attr('d', arc3)
            .style('opacity',0.7);
          
          arcs3 
          // .selectAll('text')
          // .data(ticks)
          // .enter()
          .append('circle')
          .attr('r',5)
          .attr('transform', function (d,i) {
            var ratio = scale(d);
            var newAngle = config.minAngle + ratio * range;
            return (
              'rotate(' +
              newAngle +
              ') translate(0,' +
              (config.labelInset - r) +
              ')'
            );
          })
          .attr('fill', 'black')
  
          arcs3 
          .selectAll('text')
          .data(ticks)
          .enter()
          .append('circle')
          .attr('r',4)
          .attr('transform', function (d,i) {
            var ratio = scale(d);
            var newAngle = config.minAngle + ratio * range;
            return (
              'rotate(' +
              newAngle +
              ') translate(0,' +
              (config.labelInset - r +9) +
              ')'
            );
          })
          .attr('fill', 'black')
  
          var lg = svg
            .append('g')
            .attr('class', 'label')
            .attr('transform', centerTx);
          lg.selectAll('text')
            .data(ticks)
            .enter()
            .append('text')
            .attr('transform', function (d) {
              var ratio = scale(d);
              var newAngle = config.minAngle - 3 + ratio * range;
              return (
                'rotate(' +
                newAngle +
                ') translate(0,' +
                (config.labelInset - r+2) +
                ')'
              );
            })
            .text(config.labelFormat);
  
          var lineData = [
            [config.pointerWidth/2, 0],
            [0, -pointerHeadLength],
            [-(config.pointerWidth / 2), 0],
          [0, config.pointerTailLength],
          [config.pointerWidth / 2, 0]
          ];
          // [-(config.pointerWidth / 2), 0],
          // [0, config.pointerTailLength],
          // [config.pointerWidth / 2, 0]];
          var pointerLine = d3.line().curve(d3.curveLinear);
          var pg = svg
            .append('g')
            .data([lineData])
            .attr('class', 'pointer')
            .attr('transform', centerTx)
  
          pointer = pg
            .append('path')
            .attr('d', pointerLine /*function(d) { return pointerLine(d) +'Z';}*/)
            .attr('transform', 'rotate(' + config.minAngle + ')')
            .style('opacity',0.5);
  
          update(newValue === undefined ? 0 : newValue);
        }
        else{
        svg = d3
          .select(containerId)
          .append('svg:svg')
          .attr('class', 'gauge')
          .classed("resizableSVG", true)
          .attr('id', 'svg_' + containerIdwithoutHash)
          .attr('width', config.clipWidth)
          .attr('height', config.clipHeight);
        
        if(svgWidth>300){
          var px = 30
          var gx = 195
          var fs = '9px'
        }
        else if(svgWidth>265 && svgWidth<300){
          var px = 40
          var gx = 190
          var fs = '9px'
        }
        else if(svgWidth>250 && svgWidth<265){
          var px = 50
          var gx = 185
          var fs = '9px'
        }
        else if(svgWidth<250){
          var px = 35
          var gx = 160
          var fs = '7px'
        }
        svg.append('text')
          .attr('class', 'arc')
          .attr('dy', +165) // hard-coded. can adjust this to adjust text vertical alignment in tooltip
          .attr('dx', +px)
          .html('POOR')
          .style('font-size', fs)
          
        svg.append('text')
          .attr('class', 'arc')
          .attr('dy', +165) // hard-coded. can adjust this to adjust text vertical alignment in tooltip
          .attr('dx', +gx)
          .html('GOOD')
          .style('font-size', fs)


        var centerTx = centerTranslation();
        var color = ['#C6E3EF', '#67B7DC', '#6998D6', '#6C79CF'];

        var arcs = svg
          .append('g')
          .attr('class', 'arc')
          .attr('transform', centerTx)
          


        // arcs
        //   .selectAll('path')
        //   .data(tickData)
        //   .enter()
        //   .append('path')
        //   .attr('d', arc)
        //   .attr('fill', (d, i) => {
        //     return color[i % color.length];
        //   })
        arcs
          .append("linearGradient")
          .attr("id", "line-gradient")
          .attr("gradientUnits", "userSpaceOnUse")
          .attr("x1", -90)
          .attr("y1", 10)
          .attr("x2", 60)
          .attr("y2", 25)
          .attr("x3", 70)
          .attr("y3", 50)
          .attr("x4", 75)
          .attr("y4", 75)
          .selectAll("stop")
          .data([
            { offset: "0%", color: "#C6E3EF" },
            { offset: "25%", color: "#67B7DC" },
            { offset: "50%", color: "#6998D6" },
            { offset: "100%", color: "#6C79CF" }

          ])
          .enter().append("stop")
          .attr("offset", function (d) { return d.offset; })
          .attr("stop-color", function (d) { return d.color; });

        arcs
          .selectAll('path')
          .data(tickData)
          .enter()
          .append('path')
          .attr('d', arc)
          .attr("fill", "url(#line-gradient)")
          .attr("stroke", "url(#line-gradient)")
          .attr("stroke-width", 2)


        var arcs1 = svg
          .append('g')
          .attr('class', 'arc1')
          .attr('transform', centerTx)
        
          if(svgWidth>240){
            var ip=115
            var fsize = '13px'
          }
          else{
            var ip=95
            var fsize = '12px'
          }
        svg.append('text')
          .attr('class', 'arc')
          .attr('dy', +140) // hard-coded. can adjust this to adjust text vertical alignment in tooltip
          .attr('dx', +ip)
          .html(input[0] + "%")
          .style('font-size', fsize)
          .style('fill', 'white')

        arcs1
          .selectAll('path')
          .data(tickData)
          .enter()
          .append('path')
          .attr('fill', function (d, i) {
            return config.arcColorFn();
          })
          .attr('d', arc1)
          .style('opacity', 0.8);

        var arcs2 = svg
          .append('g')
          .attr('class', 'arc2')
          .attr('transform', centerTx);

        arcs2
          .selectAll('path')
          .data(tickData)
          .enter()
          .append('path')
          .attr('fill', function (d, i) {
            return config.arcColorFn();
          })
          .attr('d', arc2)
          .style('opacity', 0.7);

        var arcs3 = svg
          .append('g')
          .attr('class', 'arc3')
          .attr('transform', centerTx);

        arcs3
          .selectAll('path')
          .data(tickData)
          .enter()
          .append('path')
          .attr('fill', function (d, i) {
            return config.arcColorFn();
          })
          .attr('d', arc3)
          .style('opacity', 0.7);

        arcs3
          // .selectAll('text')
          // .data(ticks)
          // .enter()
          .append('circle')
          .attr('r', 5)
          .attr('transform', function (d, i) {
            var ratio = scale(d);
            var newAngle = config.minAngle + ratio * range;
            return (
              'rotate(' +
              newAngle +
              ') translate(0,' +
              (config.labelInset - r) +
              ')'
            );
          })
          .attr('fill', 'black')

        arcs3
          .selectAll('text')
          .data(ticks)
          .enter()
          .append('circle')
          .attr('r', 3)
          .attr('transform', function (d, i) {
            var ratio = scale(d);
            var newAngle = config.minAngle + ratio * range;
            return (
              'rotate(' +
              newAngle +
              ') translate(0,' +
              (config.labelInset - r + (svgWidth/7)) +
              ')'
            );
          })
          .attr('fill', 'black')

        var lg = svg
          .append('g')
          .attr('class', 'label')
          .attr('transform', centerTx);
        lg.selectAll('text')
          .data(ticks)
          .enter()
          .append('text')
          .style('font-size', '11px')
          .attr('transform', function (d) {
            var ratio = scale(d);
            var newAngle = config.minAngle - 3 + ratio * range;
            return (
              'rotate(' +
              newAngle +
              ') translate(0,' +
              (config.labelInset - r + ((svgWidth/7) - 5)) +
              ')'
            );
          })
          .text(config.labelFormat);

        var lineData = [
          [config.pointerWidth / 2, 0],
          [0, -pointerHeadLength],
          [-(config.pointerWidth / 2), 0],
          [0, config.pointerTailLength],
          [config.pointerWidth / 2, 0]
        ];
        // [-(config.pointerWidth / 2), 0],
        // [0, config.pointerTailLength],
        // [config.pointerWidth / 2, 0]];
        var pointerLine = d3.line().curve(d3.curveLinear);
        var pg = svg
          .append('g')
          .data([lineData])
          .attr('class', 'pointer')
          .attr('transform', centerTx)

        // svg.append('text')
        // .attr('class', 'arc')
        // .attr('dy', +140) // hard-coded. can adjust this to adjust text vertical alignment in tooltip
        // .attr('dx',+143)
        // .html('30%') 
        // .style('font-size', '11px')
        // .style('fill', 'darkOrange')

        pointer = pg
          .append('path')
          .attr('d', pointerLine /*function(d) { return pointerLine(d) +'Z';}*/)
          .attr('transform', 'rotate(' + config.minAngle + ')')
          .style('opacity', 0.5);

        update(newValue === undefined ? 0 : newValue);
      }
    }
      that.gaugemap.render = render;
      function update(newValue, newConfiguration?) {
        if (newConfiguration !== undefined) {
          configure(newConfiguration);
        }
        var ratio = scale(newValue);
        var newAngle = config.minAngle + ratio * range;
        pointer
          .transition()
          .duration(config.transitionMs)
          .ease(d3.easeElastic)
          .attr('transform', 'rotate(' + newAngle + ')');
      }
      that.gaugemap.update = update;
      configure(configuration);

      return that.gaugemap;
    };
    if(containerId=="#container_0"){
      var powerGauge = gauge('#power-gauge', {
        size: 300,
        clipWidth: svgWidth,
        clipHeight: svgHeight,
        ringWidth: 50,
        maxValue: 100,
        transitionMs: 4000,
      });
      powerGauge.render(this.input[0]);
    }
    else{
    var powerGauge = gauge('#power-gauge', {
      size: svgWidth+20,
      clipWidth: svgWidth,
      clipHeight: svgHeight,
      ringWidth: svgWidth/7.5,
      maxValue: 100,
      transitionMs: 4000,
    });
    powerGauge.render(this.input[0]);
  }
  }
}



